import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "components/ui/dialog";
import { useGetConsoleBillInquiryDetail } from "hooks/console/useGetConsoleBillInquiryDetail";

type Props = {
    category: string;
    listNo: number;
    count: number;
};

export default function ConsoleBillCommentDialog({ category, listNo, count }: Props) {
    const [open, setOpen] = useState(false);
    const { data, isLoading } = useGetConsoleBillInquiryDetail({
        category,
        list_no: open ? String(listNo) : "",
    });

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <button
                    type="button"
                    onClick={e => e.stopPropagation()}
                    className="text-[#4F46E5] hover:underline ml-1"
                >
                    ({count})
                </button>
            </DialogTrigger>
            <DialogContent
                className="bg-white p-0 gap-0 max-w-[600px]"
                onClick={e => e.stopPropagation()}
            >
                <DialogHeader className="border-b border-[#dddddd] p-[24px_32px_16px]">
                    <DialogTitle className="text-[20px]">댓글 ({count})</DialogTitle>
                    <DialogDescription hidden />
                </DialogHeader>
                <div className="px-[32px] py-[20px] max-h-[60vh] overflow-y-auto">
                    {isLoading ? (
                        <p className="text-center text-[#999] py-6">불러오는 중...</p>
                    ) : !data?.comment?.length ? (
                        <p className="text-center text-[#999] py-6">댓글이 없습니다.</p>
                    ) : (
                        <div className="flex flex-col">
                            {data.comment.map(c => (
                                <div key={c.c_list_no} className="border-t py-[12px] flex flex-col gap-y-1">
                                    <div className="flex gap-2 items-center">
                                        <span className="text-[#1A2448] font-bold min-w-[60px]">{c.c_name}</span>
                                        <span className="text-[#999999] text-[14px]">
                                            {c.c_wdate.substring(5, 10) + " " + c.c_wdate.substring(11, 16)}
                                        </span>
                                    </div>
                                    <p className="whitespace-pre-wrap text-[#666666]">{c.c_content}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}
